<template>
  <artmisads-modal
    v-model:open="visible"
    :title="title"
    :width="currentStep === 1 ? 1200 : 800"
    :footer="null"
    @cancel="handleClose"
  >
   
    <div class="partnership-modal-content" v-if="currentStep === 1">
      <div class="single-top">
        <LogoImage
          :maxWidth="'95%'"
          :logoUrl="logoImageUrl"
          :brandName="name"
          :width="51"
          :height="51"
          :lineHeight="6"
          :fontSize="10"
          :borderRadius="4"
        />
        <span>{{ name }} </span>
      </div>
      <div class="bottom">
         <a-spin :spinning="loading">
        <div class="left" ref="leftScrollRef" @scroll="handleScroll">
          <div class="left-top">
            <a-input v-model:value="value5">
              <template #addonAfter >
                <Icon name="sousuo" class="icon-svg" @click="search"/>
              </template>
            </a-input>
          </div>
          <div class="bottom-select">
            <div v-for="value in data">
               <div class="item" v-if="!value.currentCommissionDetail">
                <a-checkbox
                  v-model:checked="value.checked"
                  @change="changeItem"
                >
                  <div class="item-left-box">
                    <div class="item-left">
                      <LogoImage
                        :maxWidth="'95%'"
                        :logoUrl="value?.publicImage"
                        :brandName="value?.creatorName"
                        :width="48"
                        :height="48"
                        :lineHeight="14"
                        :fontSize="10"
                      />
                    </div>

                    <div class="item-right">
                      <div class="item-text">
                        {{ value?.creatorName }}{{ value?.hasDuplicate ? `(${value?.amazonProfileAccountInfoName})` : '' }}
                      </div>
                      <div class="item-bottom" v-if="value.currentCommissionDetail">
                        <div class="item-bottom-left">{{value.currentCommissionDetail?.commissionRate}}%</div>
                        <div class="item-bottom-right">End Date {{value.currentCommissionDetail?.endDateStr}}</div>
                      </div>
                    </div>
                  </div>
                </a-checkbox>
              </div>
             <a-popover
              :mouseLeaveDelay="1"
              placement="right"
              arrow-point-at-center
              v-if="value.currentCommissionDetail"
            >
              <template #content >
                <div class="text">
                  The commission rates for media partners and their cooperation
                  expiration dates can be viewed here.
                </div>
                <div class="item-bottom bottom-select-bottom" >
                  <div class="item-bottom-left">{{value.currentCommissionDetail?.commissionRate}}%</div>
                  <div class="item-bottom-right">End Date {{value.currentCommissionDetail?.endDateStr}}</div>
                </div>
              </template>
              <div class="item">
                <a-checkbox
                  v-model:checked="value.checked"
                  @change="changeItem"
                >
                  <div class="item-left-box">
                    <div class="item-left">
                      <LogoImage
                        :maxWidth="'95%'"
                        :logoUrl="value?.publicImage"
                        :brandName="value?.creatorName"
                        :width="48"
                        :height="48"
                        :lineHeight="14"
                        :fontSize="10"
                      />
                    </div>

                    <div class="item-right">
                      <div class="item-text">
                        {{ value?.creatorName }}{{ value?.hasDuplicate ? `(${value?.amazonProfileAccountInfoName})` : '' }}
                      </div>
                      <div class="item-bottom" v-if="value.currentCommissionDetail">
                        <div class="item-bottom-left">{{value.currentCommissionDetail?.commissionRate}}%</div>
                        <div class="item-bottom-right">End Date {{value.currentCommissionDetail?.endDateStr}}</div>
                      </div>
                    </div>
                  </div>
                </a-checkbox>
              </div>
            </a-popover>
            </div>
           
          </div>
        </div>
        </a-spin>
        <div class="right">
          <div class="right-title">
            <span class="selected-count">{{type.value==='publisher'?'Selected Publisher':'Selected Brands'}}</span> (<span
              class="selected-count"
              >{{ currentTags.length }}</span
            ><span class="total-count">/100</span>)
          </div>
          <div class="right-content">
            <div class="empty-content" v-if="currentTags.length === 0">
              <a-empty />
            </div>
            <div class="tags-container">
              <div v-for="tag in currentTags" :key="tag.id" class="tag-item">
                <LogoImage
                  :maxWidth="'95%'"
                  :logoUrl="tag?.publicImage"
                  :brandName="tag?.creatorName"
                  :width="20"
                  :height="20"
                  :lineHeight="6"
                  :fontSize="5"
                  :borderRadius="4"
                />
                <span
                  >{{ tag.creatorName }}
                  {{ tag.hasDuplicate ? `(${tag.amazonProfileAccountInfoName})` : '' }}
                </span>
                <Icon
                  @click.stop="removeTag(tag)"
                  name="a-error-tianchong5"
                  class="icon-svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-btn">
        <artmisads-button type="primary" @click="handleSave" :loading="saving" :disabled="currentTags.length === 0">
          Next
        </artmisads-button>
      </div>
    </div>
    
    <setPartnershipSecond
      ref="partnershipSecondRef"
      @refresh="refresh"
      @back="handleBack"
      :currentTags="showCurrentTags"
      v-if="currentStep === 2"
    />
  </artmisads-modal>
</template>
<script setup>
import { ref, defineExpose, onMounted, onUnmounted,nextTick,defineEmits } from 'vue'
import LogoImage from '@/components/LogoImage.vue'
import Icon from '@/components/Icon.vue'
import setPartnershipSecond from './setPartnershipSecond.vue'
import { publishersApi } from '@/server'
import { message, notification } from 'ant-design-vue'
import { countBrandNames } from '~/utils'
const emit = defineEmits(['refresh','back'])
const visible = ref(false)
const partnershipSecondRef = ref(null)
const title = ref('Set Up Partnership for Brand')
const value5 = ref('')
const currentStep = ref(1)
const brandId = ref('')
const name = ref('')
const amazonName = ref('')
const logoImageUrl = ref('')
const type = ref('')
const choiceType = ref('')
const loading = ref(false)
const params = ref({
  page: 1,
  pageSize: 10,
  total: 0,
})
const openPopover = ref(true)
const data = ref([])
const currentTags = ref([])
const showCurrentTags=ref([])
const leftScrollRef = ref(null)
const isLoadingMore = ref(false)
const handleClose = () => {
  closeModal()
}
const changeItem = (item) => {
  if(currentTags.value.length>=100){
    message.error('You can only select up to 100 items')
    return
  }
  item.checked = !item.checked
  currentTags.value = data.value.filter((tag) => tag.checked)
  showCurrentTags.value= currentTags.value.filter(item=>{
    return item.currentCommissionDetail
  })
 
}
const closeModal = () => {
  visible.value = false
}
const show = (
  id,
  propsName,
  propsNameamazonBrandNameStr,
  imageUrl,
  propsType,
) => {
  params.value.page=1
  currentStep.value = 1
  brandId.value = id
  name.value = propsName
  amazonName.value = propsNameamazonBrandNameStr
  logoImageUrl.value = imageUrl
  type.value = propsType
  currentTags.value = []
  value5.value=''
  visible.value = true
  // 滚动条滚动到最上面
  nextTick(() => {
    if (leftScrollRef.value) {
      leftScrollRef.value.scrollTop = 0
    }
  })
  if(type.value==='publisher'){
    getPublishersList()
    title.value=' Set Up Partnership for Brand'
  }
  if(type.value==='brands'){
    getBrandsList()
    title.value='Set Up Partnership'
  }
}
const search = async() => {
    params.value.page=1
  nextTick(() => {
    if (leftScrollRef.value) {
      leftScrollRef.value.scrollTop = 0
    }
  })
  if(type.value==='publisher'){
    getPublishersList()
  }
  if(type.value==='brands'){
    getBrandsList()
  }
}
const removeTag = (tag) => {
  currentTags.value = currentTags.value.filter((item) => item.id !== tag.id)
  data.value.forEach((item) => {
    if (item.id === tag.id) {
      item.checked = false
    }
  })
}

const handleSave = async() => {
  if(type.value==='publisher'){
  
     currentTags.value.map(item=>{
        item.brandId=brandId.value
      })
  }
  if(type.value==='brands'){
  currentTags.value.map(item=>{
        item.id=brandId.value
      })
  }
  currentStep.value = 2

  await nextTick()
  partnershipSecondRef.value?.showModal(showCurrentTags.value,type.value,currentTags.value)
}

const handleScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target
  // 当滚动到底部时（留有一点余量）
  if (scrollTop + clientHeight >= scrollHeight - 10 && !isLoadingMore.value) {
    // 检查是否还有更多数据可加载
    if (params.value.page * params.value.pageSize < params.value.total) {
      loadMoreData()
    }
  }
}

const loadMoreData = async () => {
  if (isLoadingMore.value) return

  isLoadingMore.value = true
  params.value.page += 1

  try {
    let res
    if(type.value==='publisher'){
      res = await publishersApi.getPublishersByBrandId({
        page: params.value.page,
        size: params.value.pageSize,
        brandId: brandId.value,
        keyword:value5.value
      })
    }
    if(type.value==='brands'){
      res = await publishersApi.getPublisherDetail({
        page: params.value.page,
        size: params.value.pageSize,
        publisherId: brandId.value,
        keyword:value5.value
      })
    }

    if (res.success) {
      let newData
      if(type.value==='publisher'){
        newData = res.data?.data?.map((item) => ({
          ...item.publisherVO,
          associateBrandCount: item?.associateBrandCount,
          currentCommissionDetail: item?.currentCommissionDetail,
          checked: false,
        }))
      }
      if(type.value==='brands'){
        const brandNameCount = countBrandNames(res.data?.data,'brandVO.amazonBrandName')
        newData = res.data?.data?.map((item) => ({
         ...item.brandVO,
          creatorName: item.brandVO.amazonBrandName || '',
          publicImage: item.brandVO.logoImageUrl || '',
          nextMonthCommissionDetail: item.nextMonthCommissionDetail,
          status: item.status,
          startDateStr: item.startDateStr,
          endDateStr: item.endDateStr,
          publisherId: item.publisherId,
          brandId: item.brandId,
          commissionRate: item?.currentCommissionDetail?.commissionRate,
          lastCommissionRate: item?.lastCommissionRate,
          currentCommissionDetail: item.currentCommissionDetail,
          hasDuplicate:
            item.brandVO.amazonBrandName &&
            brandNameCount[item.brandVO.amazonBrandName] > 1,
          checked: false,
        }))
      }

      // 过滤有效的链接
      newData?.forEach((item) => {
        if (item?.links) {
          item.links = item?.links?.filter((link) => link.url)
        }
      })

      // 将新数据添加到现有数据中
      data.value = [...data.value, ...newData]
      params.value.total = res.data.total
    } else {
      message.error(res.error)
      // 加载失败时回滚页码
      params.value.page -= 1
    }
  } catch (error) {

    message.error('Failed to load more data')
    // 加载失败时回滚页码
    params.value.page -= 1
  } finally {
    isLoadingMore.value = false
  }
}
const getPublishersList = async () => {
  loading.value = true
  try {
    const res = await publishersApi.getPublishersByBrandId({
      page: params.value.page,
      size: params.value.pageSize,
      brandId: brandId.value,
      keyword:value5.value,
    })
    if (res.success) {
      data.value = res.data?.data?.map((item) => ({
        ...item.publisherVO,
             currentCommissionDetail: item.currentCommissionDetail,
        associateBrandCount: item.associateBrandCount,
      }))
      data.value?.forEach((item) => {
        if (item?.links) {
          item.links = item?.links?.filter((link) => {
            return link.url
          })
        }
      })
      params.value.total = res.data.total
    } else {
      message.error(res.error)
    }
  } catch (error) {
    message.error('Failed to get data')
  } finally {
    loading.value = false
  }
}
const getBrandsList = async () => {
  loading.value = true
  try {
    const res = await publishersApi.getPublisherDetail({
      page: params.value.page,
      size: params.value.pageSize,
      publisherId: brandId.value,
      keyword:value5.value
    })
    if (res.success) {
      const brandNameCount = countBrandNames(res.data?.data,'brandVO.amazonBrandName')
      data.value = res.data?.data?.map((item) => {
         return {
          ...item.brandVO,
          creatorName: item.brandVO.amazonBrandName || '',
          publicImage: item.brandVO.logoImageUrl || '',
          nextMonthCommissionDetail: item.nextMonthCommissionDetail,
          status: item.status,
          startDateStr: item.startDateStr,
          endDateStr: item.endDateStr,
          publisherId: item.publisherId,
          brandId: item.brandId,
          currentCommissionDetail:item?.currentCommissionDetail,
          commissionRate: item?.currentCommissionDetail?.commissionRate,
          lastCommissionRate: item?.lastCommissionRate,
          hasDuplicate:
            item.brandVO.amazonBrandName &&
            brandNameCount[item.brandVO.amazonBrandName] > 1,
        }
      })
      params.value.total = res.data.total
    } else {
      message.error(res.error)
    }
  } catch (error) {
    message.error('Failed to get data')
  } finally {
    loading.value = false
  }
}
const refresh = () => {
  params.value.page = 1
  value5.value=''
  if(type.value==='publisher'){
    getPublishersList()
  }
  if(type.value==='brands'){
    getBrandsList()
  }
  currentTags.value = []
  currentStep.value = 1
  visible.value = false
  emit('refresh')
}
const handleBack = () => {
  currentStep.value = 1
}
defineExpose({
  show,
})
</script>
<style lang="less" scoped>
.bottom-btn {
  display: flex;
  justify-content: flex-end;
  height: 72px;
  align-items: center;
}
.ant-modal-body {
  padding-bottom: 0px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.bottom-select-bottom {
  margin-top: 10px;
}

.item:hover {
  background-color: #f5f3f9;
}
:deep(.ant-popover) {
  :deep(.ant-popover-arrow-content:before) {
    background-color: #262626!important;
  }
  :deep(.ant-popover-inner) {
    border-radius: 8px;
    background: #262626 !important;
    padding: 20px;
    .text {
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      letter-spacing: 0.3px;
      color: #fff;
    }
  }
}
:deep(.ant-popover-inner) {
  border-radius: 8px;
  background: #262626 !important;
  color: #ffffff;
}
.item-bottom {
  display: flex;
  height: 20px;
  width: 186px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #835cf266;
  background-color: #fff;
  .item-bottom-left {
    // width: 37px;
    padding: 0 5px;
    text-align: center;
    display: inline-flex;
    height: 20px;
    line-height: 20px;
    justify-content: center;
    align-items: center;
    background: #8a64f4;
    color: #ffffff;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Sora';
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
  }
  .item-bottom-right {
    text-align: center;
    flex: 1;
    height: 20px;
    line-height: 20px;
    align-items: center;
    color: #694ac2;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Sora';
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    background: rgba(131, 92, 242, 0.1);
  }
}
.single-top {
  display: flex;
  width: 321px;
  height: 72px;
  padding: 4px 16px;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: #50408014;
  margin-bottom: 20px;
}
.bottom {
  display: flex;
  align-items: flex-start;

  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Border-, #e8e5ed);
  .input-search {
    width: 284px;
    height: 32px;

    border-radius: 8px;
  }
  .bottom {
    height: 548px;
  }
  .left {
    height: 548px;
    overflow-y: auto;
    padding: 16px;
    border-right: 1px solid var(--Border-, #e8e5ed);
    .left-top {
    }

    .bottom-select {
      .item {
        padding: 6px 8px;
        margin: 8px 0;
        display: flex;
        align-items: center;
        gap: 12px;
        border-radius: 8px;
        .item-left-box {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .item-left {
          overflow: hidden;
          border-radius: 8px;
          border: 1px solid var(--Border-, #e8e5ed);
        }
        .item-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .item-text {
            color: #0f0629;
            font-family: 'Sora';
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            padding-bottom: 4px;
          }
        }
      }
    }
  }
  .right {
    padding: 20px;
    flex: 1;
    height: 548px;
    display: flex;
    flex-direction: column;
    .right-title {
      .selected-count {
        color: rgb(0, 0, 0);
        font-family: 'Sora';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
      }
      .total-count {
        color: rgba(15, 6, 41, 0.5);
        font-family: 'PingFang SC';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
      }
    }
    .right-content {
      margin-top: 10px;
      flex: 1;
      .empty-content {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .tags-container {
        // min-height: 60px;
        // padding: 12px;
        // border: 1px dashed #d9d9d9;
        // border-radius: 6px;
        // background: #50408014;

        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        .tag-item {
          display: flex;
          padding: 3px 4px;
          align-items: center;
          gap: 6px;
          border-radius: 6px;
          background: #f1f0f5;
          // margin: 4px 8px 4px 0;
          // padding: 4px 8px;

          font-size: 13px;

          font-weight: 400;
          line-height: 15px;
          letter-spacing: 0.3px;
          .icon-svg {
            color: rgba(15, 6, 41, 0.3);
            cursor: pointer;
          }
          span {
            font-family: 'Sora';
            opacity: 0.7;
            color: #0f0629;
          }
        }
      }
    }
  }
}
</style>
